<template>
  <smd-one-col-layout class="view-files-labtests"
                      :content-styles="contentStylesClass">
    <smd-search class="m-t-15"
                placeholder="Search lab tests"
                slot="toolbar"
                v-model="search"
                v-if="$isMobile"/>

    <smd-search class="m-b-50"
                placeholder="Search lab tests"
                v-model="search"
                v-else/>

    <div class="cover" v-if="!filteredFiles.length">
      <empty-state type="recordsLabTests" :variant="search !== '' ? 'filter' : 'empty'"/>
    </div>
    <template v-else>
      <component v-for="(file, fileIndex) in filteredFiles"
                :key="fileIndex"
                :is="getFileComponent(file)"
                :file-data="file"/>
    </template>
  </smd-one-col-layout>
</template>

<script>
  import FilesMixin from "@/views/files/files-mixin";
  import {mapGetters} from "vuex";
  import {GETTER_FILES_FROM_DOC_LAB_TESTS} from "@/store/types";

  export default {
    name: "view-files-labtests",
    mixins: [FilesMixin],
    computed: {
      ...mapGetters({
        files: GETTER_FILES_FROM_DOC_LAB_TESTS,
      }),
      contentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'view-files-labtests__content']
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .view-files-labtests__content {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

      .smd-form--search {
        max-width: 792px;
      }
    }
  }
</style>